<template>
  <section class="welcome-title-section">
    <article class="container">
      <header>
        <h1>
          Сырье для вашего<br>
          бизнеса на GOT.MARKET
        </h1>
      </header>

      <div class="content">
        Наша специализация — сырье для косметической,<br>
        фармацевтической и пищевой промышленности.
      </div>

      <div class="slider">
        <transition-group
          class="slides-wrap"
          name="slides"
          tag="div"
        >
          <article
            v-for="(slide, index) in slides"
            :key="'slide_' + index"
            class="slider-item"
            :class="{ active: activeSlideIndex === index }"
          >
            <header>{{ slide.title }}</header>
            <ul>
              <li
                v-for="(item, fIndex) in slide.features"
                :key="'slide_' + index + '_feature_' + fIndex"
              >
                {{ item }}
              </li>
            </ul>

            <ActionButton :action="slide.action">
              {{ slide.button }}
            </ActionButton>
          </article>
        </transition-group>

        <header>
          <span
            v-for="(item, index) in slides"
            :key="'dot_' + index"
            class="dot"
            :class="{ active: activeSlideIndex === index }"
            @click="setActiveSlide(index)"
          />
        </header>
      </div>
    </article>
  </section>
</template>

<style lang="scss" src="./SectionWelcomeTitle.scss"/>

<script>
import ActionButton from '../ActionButton/ActionButton.vue';
export default defineComponent({
	name:       'SectionWelcomeTitle',
	components: { ActionButton },

	data() {
		const slides = [
			{
				title:    'Упростим процесс выбора',
				features: ['Удобный поиск', 'Тестовые образцы', 'Отсрочка платежа'],
				button:   'Подать заявку',
				action:   'register',
			},
			{
				title:    'Управляйте легко',
				features: ['Мониторинг заказов', 'Быстрые сделки', 'Разные объемы партий'],
				button:   'Зарегистрироваться',
				action:   'register',
			},
		];

		return {
			slides,
			intervalId:       null,
			activeSlideIndex: 0,
		};
	},

	mounted() {
		this.intervalId = setInterval(
			() => this.setActiveSlide(this.activeSlideIndex === 0 ? 1 : 0),
			11000,
		);
	},

	beforeUnmount() {
		if (this.intervalId !== null) {
			clearInterval(this.intervalId);
		}
	},

	methods: {
		setActiveSlide(index) {
			this.activeSlideIndex = index;
		},
	},
});
</script>
